import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { EDUCATION } from '../utils/constants';

const About = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.55 } }
  };

  return (
    <section className="section-padding bg-off-white">
      <motion.div
        ref={ref}
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
        className="container-custom"
      >
        <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-[0.65fr_1.35fr] gap-10 lg:gap-16">
          <motion.div variants={itemVariants}>
            <p className="text-sm uppercase tracking-[0.2em] text-gold font-semibold mb-3">About</p>
            <h2 className="text-4xl md:text-5xl font-serif text-navy">
              Building around how buyers actually move.
            </h2>
          </motion.div>

          <motion.div variants={itemVariants} className="space-y-6">
            <p className="text-xl text-charcoal leading-relaxed">
              I&apos;m Anu Singh, Co-Founder and CEO of Zakool AI. My work focuses on a question that is becoming increasingly important for real estate: what happens when AI moves beyond answering questions and becomes part of the infrastructure behind the buyer journey?
            </p>
            <p className="text-lg text-charcoal leading-relaxed">
              Property buyers move between websites, messaging, phone conversations, sales teams and CRM systems. Too often, context disappears at every handoff. I believe the next generation of real estate technology will be built around continuity: preserving buyer intent, helping people make decisions, and bringing human sales teams into the journey when their judgment and expertise matter most.
            </p>
            <p className="text-lg text-charcoal leading-relaxed">
              Before PropTech, I spent nearly a decade in travel technology, working within an ecosystem that included major global travel platforms and distribution technologies. I later built businesses in travel. That experience shaped how I think about digital behaviour, distribution and the infrastructure that sits behind a customer journey.
            </p>

            <div className="pt-4 border-t border-gray-200">
              <p className="text-sm uppercase tracking-[0.18em] text-navy/60 font-semibold mb-4">Education</p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {EDUCATION.map((edu) => (
                  <div key={`${edu.degree}-${edu.institution}`}>
                    <p className="text-sm font-medium text-navy">{edu.degree}</p>
                    <p className="text-sm text-charcoal/70">{edu.institution}</p>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};

export default About;
